import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { SESSION_STORAGE_RETURNED_KEY } from '../../utils/constants'
import { AppHeader } from '../app/AppHeader'
import { TaskPage } from './TaskPage'

export type RecordProps = {
    record: { id: string }
}

/** @deprecated Remove once we implement Tasks using the 2025 Design system */
export const BaseRecordPage = () => {
    const { recordType, recordID } = useParams<{ recordType: string; recordID: string }>()
    const location = useLocation()
    const navigate = usePSNavigate()

    const onBack = useMemo(() => {
        if (location.state?.returnAddress) {
            return () => {
                sessionStorage.setItem(SESSION_STORAGE_RETURNED_KEY, 'true')
                navigate(location.state.returnAddress, location)
            }
        }
        return undefined
    }, [])

    let title
    switch (recordType) {
        case 'signup':
            title = 'Client'
            break
        case 'task':
            title = 'Task'
            break
        default:
            title = 'Details'
    }

    const data = { id: recordID }
    // Verify the data.id and recordID are the same, since we reuse this
    // component and the state is stored globally, it can be the old state
    // for a brief moment when we navigate backwards
    let recordView
    if (data?.id !== undefined && data.id === recordID) {
        // this seems to be a TS bug, probably will go away when we upgrade versions
        let _data = data as { id: string }
        switch (recordType) {
            case 'task':
                recordView = <TaskPage record={_data} />
                break
        }
    }

    return (
        <AppHeader title={title} showBackButton middleWidget={null} onBack={onBack}>
            <div style={{ margin: '32px 32px 0 32px' }}>{recordView}</div>
        </AppHeader>
    )
}
